












import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
@Component
export default class SmsTab extends Vue {
  @Prop({default: 0}) private mallNo!: number;
  private tabs = [
    {
      landingUrl: '/sms/send-list',
      tabNo: '1',
      tabName: '자동SMS 발송내역 조회'
    },
    {
      landingUrl: '/sms/usage-list',
      tabNo: '2',
      tabName: '자동SMS 사용내역 조회'
    }
  ];

  @Watch('$route.query.tabNo')
  onTabChanged(newVal: number) {
    if (!newVal) {
      const tabno = this.tabs.filter((tab: any) => this.$route.path === tab.landingUrl)[0].tabNo;
      this.$router.push({
        query: {mallNo: this.$route.query.mallNo, tabNo: tabno}
      });
    }
  }

  private mounted() {
    if (!this.$route.query.tabNo) {
      const tabno = this.tabs.filter((tab: any) => this.$route.path === tab.landingUrl)[0].tabNo;
      this.$router.push({
        query: {mallNo: this.$route.query.mallNo, tabNo: tabno}
      });
    }
  }

  private smsTabClick(urlPath:string, tabNo: string) {
    if (this.$route.path === urlPath && this.$route.query['tabNo'] === tabNo) {
        this.$router.go(0);
        return;
    }
    this.$router.push({
      path: urlPath,
      query: {mallNo: String(this.mallNo), tabNo: tabNo},
    });

  }
}
